import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/sonner";

// Lazy load pages for code splitting
const HomePage = lazy(() => import("./pages/HomePage"));
const CommentCaMarche = lazy(() => import("./pages/CommentCaMarche"));
const APropos = lazy(() => import("./pages/APropos"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Contact = lazy(() => import("./pages/Contact"));
const Estimation = lazy(() => import("./pages/Estimation"));
const AdminDashboard = lazy(() => import("./pages/Admin").then(module => ({ default: module.AdminDashboard })));
const EstimationDetail = lazy(() => import("./pages/Admin").then(module => ({ default: module.EstimationDetail })));

// Loading fallback
function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-accent/20 border-t-accent rounded-full animate-spin" />
        <p className="text-neutral-muted text-sm">Chargement...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin routes - without Layout */}
        <Route path="/admin" element={
          <Suspense fallback={<PageLoader />}>
            <AdminDashboard />
          </Suspense>
        } />
        <Route path="/admin/estimations/:id" element={
          <Suspense fallback={<PageLoader />}>
            <EstimationDetail />
          </Suspense>
        } />
        
        {/* Public routes - with Layout */}
        <Route path="/*" element={
          <Layout>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
                <Route path="/a-propos" element={<APropos />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/estimation" element={<Estimation />} />
              </Routes>
            </Suspense>
          </Layout>
        } />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
